import { render, staticRenderFns } from "./FeedbackMessageModal.vue?vue&type=template&id=0bdb40e0&scoped=true&"
import script from "./FeedbackMessageModal.vue?vue&type=script&lang=js&"
export * from "./FeedbackMessageModal.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackMessageModal.vue?vue&type=style&index=0&id=0bdb40e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdb40e0",
  null
  
)

export default component.exports